export default __webpack_public_path__ + "static/media/Seta Entrada.f9ff74a4.svg";